module.exports = __webpack_public_path__ + "img/screen-hero-collage.7ac84ac3.jpg";